/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { JobApplicationStatus } from "./JobApplicationStatus";
import {
  JobApplicationStatusFromJSON,
  JobApplicationStatusFromJSONTyped,
  JobApplicationStatusToJSON,
  JobApplicationStatusToJSONTyped,
} from "./JobApplicationStatus";

/**
 *
 * @export
 * @interface SetStatusesRequest
 */
export interface SetStatusesRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof SetStatusesRequest
   */
  applicationIds: Array<string>;
  /**
   *
   * @type {JobApplicationStatus}
   * @memberof SetStatusesRequest
   */
  status: JobApplicationStatus;
  /**
   *
   * @type {string}
   * @memberof SetStatusesRequest
   */
  note?: string | null;
}

/**
 * Check if a given object implements the SetStatusesRequest interface.
 */
export function instanceOfSetStatusesRequest(
  value: object,
): value is SetStatusesRequest {
  if (!("applicationIds" in value) || value["applicationIds"] === undefined)
    return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function SetStatusesRequestFromJSON(json: any): SetStatusesRequest {
  return SetStatusesRequestFromJSONTyped(json, false);
}

export function SetStatusesRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetStatusesRequest {
  if (json == null) {
    return json;
  }
  return {
    applicationIds: json["applicationIds"],
    status: JobApplicationStatusFromJSON(json["status"]),
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function SetStatusesRequestToJSON(json: any): SetStatusesRequest {
  return SetStatusesRequestToJSONTyped(json, false);
}

export function SetStatusesRequestToJSONTyped(
  value?: SetStatusesRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationIds: value["applicationIds"],
    status: JobApplicationStatusToJSON(value["status"]),
    note: value["note"],
  };
}
